import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VehicleTile from '../VehicleTile';
import { makeSlug } from '../../../../utils';
import { getVehiclesByBodyStyleName } from '../../../../redux/selectors/models';
import { modelLineSelectedAction } from '../../../../redux/actions/modelline';
import { getActiveBodyStyleOrAllFilterStatus } from '../../../../redux/selectors/bodyStyleFilter';

class BodyStyleRow extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    vehicles: PropTypes.array.isRequired,
    selectVehicle: PropTypes.func.isRequired,
    filterEnabled: PropTypes.bool,
  }

  static defaultProps = {
    filterEnabled: false,
  }

  renderVehicleTiles() {
    const { vehicles, selectVehicle } = this.props;
    return vehicles.map(vehicle => (
      <VehicleTile
        key={vehicle.modelLineCode}
        modelLineCode={vehicle.modelLineCode}
        year={vehicle.displayYear}
        name={vehicle.name}
        startingPrice={vehicle.startingPrice}
        onSelect={selectVehicle}
      />
    ))
  }
  render() {
    const { title, filterEnabled } = this.props;
    const slug = makeSlug(title);
    return (
      <div className={`row vehicle-grid-section ${slug}-grid`} aria-hidden={!filterEnabled}>
        <div className="columns">
          <h2 className="st-section-title st-underline margin-top-small margin-bottom-large">{title.toUpperCase()}</h2>
        </div>
        {this.renderVehicleTiles()}
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  vehicles: getVehiclesByBodyStyleName(state, ownProps.title),
  filterEnabled: getActiveBodyStyleOrAllFilterStatus(state, makeSlug(ownProps.id))
});

const mapDispatchToProps = dispatch => ({
  selectVehicle: bindActionCreators(modelLineSelectedAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BodyStyleRow);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/VehicleGrid/BodyStyleRow/infiniti.js
 **/